import React, { useContext, useState, useEffect } from "react";
import Card from "../components/UI/Card";
import AuthContext from "../store/auth-context";
import classes from "./Users.module.css";

const Users = () => {
  const AuthCtx = useContext(AuthContext);
  const [gegevens, setGegevens] = useState([]);

  useEffect(() => {
    const fetchMeals = async () => {
      const response = await fetch(
        "https://www.marchouben.nl/php/inloggegevens-get.php"
      );

      if (!response.ok) {
        throw new Error("Something went wrong!");
      }

      const responseData = await response.json();
      console.log(responseData);
      const loadedMeals = responseData;

      setGegevens(loadedMeals);
    };

    // fetchMeals is a promise so catch will work
    fetchMeals().catch((error) => {
      console.log(error.message);
    });
  }, []);

  const GegevensList = gegevens.map((gegeven) => (
    <li key={gegeven.id} className={classes.lietje}>
      {gegeven.username} <br/>  {gegeven.password}
    </li>
  ));

  return (
    <Card>
      <h1 className={classes.users} onClick={AuthCtx.onLogout}>
        Users
      </h1>
      <ul className={classes.ullie}>{GegevensList}</ul>
    </Card>
  );
};

export default Users;